module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 002.ff9ef36c.jpg";